import React from 'react';
import Terms from './terms/terms.json';
import TermsSchool from './terms/terms-school.json';
import { replaceAll } from '../../../Common/format';

const agencyKey = '%NOME_DO_ORGAO%';
const clearanceKey = '%LIBERACAO_VEICULO%';
const settlemntKey = '%LIQUIDACAO%';

// TODO Should come from API.
const DATA = {
    'GO': {
        agency: 'DETRAN Goiás',
        clearance: '2',
        settlement: '1'
    },
    'CE': {
        agency: 'DETRAN Ceará',
        clearance: '2',
        settlement: '1'
    },
    'DF': {
        agency: 'DETRAN Distrito Federal',
        clearance: '2',
        settlement: '1'
    },
    'ES': {
        agency: 'DETRAN Espírito Santo',
        clearance: '2',
        settlement: '1'
    },
    'MS': {
        agency: 'DETRAN Mato Grosso do Sul',
        clearance: '2',
        settlement: '1'
    },
    'PE': {
        agency: 'DETRAN Pernambuco',
        clearance: '2',
        settlement: '1'
    },
    'SE': {
        agency: 'DETRAN Sergipe',
        clearance: '2',
        settlement: '1'
    },
    'SP': {
        agency: 'Prefeitura de São Paulo',
        clearance: '10',
        settlement: '1'
    },
    'PI': {
        agency: 'Detran Piauí',
        clearance: '2',
        settlement: '1'
    },
    'RN': {
        agency: 'Detran Rio Grande do Norte',
        clearance: '2',
        settlement: '1'
    },
    'BILLER': {
        agency: 'órgão arrecadador',
        clearance: '2',
        settlement: '1'
    }
}


const Term = ({ protocol, state }) => {
    let terms;
    if (protocol.indexOf('EC') == 4) {
        terms = TermsSchool;
    } else {
        terms = Terms.join(' ');
        let replacement = DATA[state] || DATA['BILLER'];
        terms = replaceAll(terms, agencyKey, replacement['agency']);
        terms = replaceAll(terms, clearanceKey, replacement['clearance']);
        terms = replaceAll(terms, settlemntKey, replacement['settlement']);
    }

    return (
        <div className="card card-transparent mb-0">
            <div className="card-title border-0 pl-0">
                <h5 className="text-muted">Termo de Ciência</h5>
            </div>
            <p className="fs-13 mb-0">{terms}</p>
        </div>
    );
}

export default Term;


// WEBPACK FOOTER //
// ./src/components/Pages/Receipt/Term.js